import React, { useState, useEffect, useLayoutEffect, useRef } from 'react';
import { Link, useHistory } from "react-router-dom";
import { Row, Col, Card, CardBody, Input, Button, Table, FormGroup, Label, UncontrolledDropdown, DropdownToggle, DropdownMenu, InputGroup, InputGroupAddon } from 'reactstrap';
import Select from 'react-select';
import queryString from 'query-string'
import moment from "moment";
import { toast } from 'react-toastify';
import { cloneDeep, filter, isEmpty, isNil, startsWith } from "lodash";
import APIClient from '../../helpers/APIClient';
import PageTitle from '../../components/PageTitle';
import PageBody from '../../components/PageBody';
import Pagination from '../../components/Pagination';
import RowLoading from '../../components/RowLoading';
import RowEmpty from '../../components/RowEmpty';
import Loader from '../../components/Loader';
import ModalPopup from '../../components/ModalPopup';
import noImage from '../../assets/images/users/no-img.jpg';
import PriceUtils from '../../helpers/PriceUtils';
import { connect } from 'react-redux';
import { INVENTORY_SORT, PRODUCT_SORT, TRANG_THAI_BAN_HANG } from '../../constants/productStatus';
import InputTitleTop from '../../components/InputTitleTop';
import SelectTitleTop from '../../components/SelectTitleTop';
import Flatpickr from 'react-flatpickr'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import NavTab from '../../components/NavTab';
import FileDownload from 'js-file-download'
import { baseUrl } from '../../constants/environment';
import IconLock from '../../assets/images/icon-lock.png';
import IconUnLock from '../../assets/images/icon-unlock.png';
import IconPlus from '../../assets/images/icon-plus.png';
import IconSearch from '../../assets/images/icon-search.png';
import IconEdit from '../../assets/images/icon-edit.png';
import { ReceiptsType } from '../../constants/nutriconstant';
import TypereceiptsAdd from './TypereceiptsAdd';
import { ReceiptsGroup } from '../receipts/ReceiptsList';

const configPage = {
    titlePage: 'Danh sách loại thu chi',
    pathPage: '/setting/typereceipts',
    column: 6,
}

interface Props {
    history: any,
    location: any,
    user: any,
}
const initialParams = {
    page: 1,
    limit: 25,
    filter: {
        page: 1,
        limit: 25,
    }
}


const List: React.FC<Props> = (props: any) => {
    const [{ page, limit, filter }, setParams] = useState<any>(initialParams);
    const [totalElements, setTotalElements] = useState(0);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [action, setAction] = useState<any>({});
    const [nganh_hangs, setNganh_hangs] = useState<any>();
    const [dataCount, setDataCount] = useState<any>();
    const [ids, setIds] = useState([]);
    const searchPrams = queryString.parse(props.location.search)

    const setPage = (value: number) => {
        setParams((prevState: any) => ({
            ...prevState,
            page: value
        }));
    }

    const setLimit = (value: number) => {
        setParams((prevState: any) => ({
            ...prevState,
            limit: value
        }));
    }

    const setFilter = (value: {}) => {
        setParams((prevState: any) => ({
            ...prevState,
            filter: value
        }));
    }

    useEffect(() => {
        document.title = configPage.titlePage
    }, []);

    useEffect(() => {
        loadData()
        setFilterParams({
            page:page,
            limit: limit,
            ...filter,
        });
    }, [filter, page, limit]);

    const handleActionModal = (item: any) => {
        setAction(item)
        setIsOpen(true);
    }

    const setFilterParams = (params: any) => {
        var filterParams = ''
        Object.keys(params).map(function (item, i) {
            if (i === 0) {
                if (params[item]) filterParams = filterParams + '?' + item + '=' + params[item]
            } else {
                if (params[item]) filterParams = filterParams + '&' + item + '=' + params[item]

            }
        });
        props.history.push({
            search: filterParams
        })
    }

    const loadData = async () => {
        setLoading(true);
        const formData = {
            page: page,
            limit: limit,
            ...filter,
        }
        if(formData?.name === "") {
            delete formData?.name
        }
        if(formData?.status === "") {
            delete formData?.status
        }
        const url = `${baseUrl}/receiptstype`;
        let response: any = await APIClient.GET(url, formData);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error)
        } else if (response.response?.data !== undefined) {
            setData(response.response?.data)
            setTotalElements(response.response?.total)
        }
    }



    return (
        <React.Fragment>
            <PageTitle
                breadCrumbItems={[
                    { label: configPage.titlePage, active: true },
                ]}
                title={configPage.titlePage}
            />
            <PageBody>
                <DataFilter
                    filter={filter}
                    configPage={configPage}
                    setFilter={(filter: any) => setFilter(filter)}
                    handleActionModal={(data: any) => handleActionModal(data)}
                />
                <DataTableList
                    user={props?.user}
                    data={data} loading={loading}
                    page={page} limit={limit}
                    configPage={configPage}
                    history={props.history}
                    handleActionModal={(data: any) => handleActionModal(data)}
                />
                <Pagination
                    link={configPage.pathPage + '/list'}
                    setPage={(page: number) => setFilter({...filter, page:page})}
                    page={filter?.page}
                    limit={filter?.limit}
                    setLimit={(limit: number) => setFilter({...filter, limit:limit})}
                    type={'noresetpage'}
                    totalElements={totalElements}
                />
            </PageBody>
            <ModalPopup
                isOpen={modalIsOpen}
                onRequestClose={() => setIsOpen(false)}
            >
                {action?.type === 'add' ? 
                    <TypereceiptsAdd closeModal={() => setIsOpen(false)} action={action} loadData={() => loadData()}/>
                :action?.type === 'view' ? 
                    <TypereceiptsAdd closeModal={() => setIsOpen(false)} action={action} loadData={() => loadData()} onlyView={true}/>
                :action?.type === 'edit' ? 
                <TypereceiptsAdd closeModal={() => setIsOpen(false)} action={action} loadData={() => loadData()}/>
                : <RenderActionModal closeModal={() => setIsOpen(false)} action={action} loadData={() => loadData()}/>
                }
            </ModalPopup>
        </React.Fragment>
    );
};

const DataTableList = (props: any) => {
    const { data, filter, loading, limit, page, is_draft, configPage, handleActionModal} = props
    const start = limit * (page - 1)
    const RenderHeadData = () => {
        return (
            <thead>
                <tr>
                    <th style={{ minWidth: 120 }}>Tên loại thu chi</th>
                    <th style={{ minWidth: 120 }}>Loại</th>
                    <th style={{ minWidth: 120 }}>Phân nhóm thu chi</th>
                    <th style={{ minWidth: 120 }}>Ghi chú</th>
                    <th style={{ width: 100 }} >Thao tác</th>
                </tr>
            </thead>
        )
    }
    const RenderBobyData = () => {
        const router = useHistory()
        if (loading) {
            return <RowLoading column={configPage.column} row={data.length || limit} />
        }
        
        if (data.length === 0) {
            return <RowEmpty column={configPage.column} title="Chưa có loại thu chi nào!" />;
        }

        const gotoDetail = (item:any) => {
            props?.handleActionModal({type: 'view', data: item})
        }

        return (
            <tbody>
                {data && data.map((item: any, index: number) => {
                    return (
                        <tr key={index}>
                            <td onClick={() => gotoDetail(item)}>{item?.name}</td>
                            <td onClick={() => gotoDetail(item)}>{getLabelByValue(ReceiptsType, item?.type)}</td>
                            <td onClick={() => gotoDetail(item)}>{getLabelByValue(ReceiptsGroup, item?.classify)}</td>
                            <td onClick={() => gotoDetail(item)}>{item?.note}</td>
                            <td>
                                <div className="table-action">
                                    <div className="button-nutri" onClick={() => props?.handleActionModal({type: 'edit', data: item})}><img width={20} height={20} src={IconEdit} alt="edit" /></div>
                                    <div className="button-nutri" onClick={() => props?.handleActionModal({type: 'delete', data: item})}><i className='uil-trash-alt'></i></div>
                                </div>
                            </td>
                        </tr>
                    )
                })}
            </tbody>
        )
    }

    return (
        <div>
            <Table className="mb-0 table-custom" responsive>
                <RenderHeadData />
                <RenderBobyData />
            </Table>
            {loading && <Loader />}
        </div>
    );
};

const getLabelByValue = (data:any, value:any) => {
    const result = data?.filter((item:any)=>{
        return item?.value === value
    })
    return result[0]?.label || ''
}

const DataFilter = (props: any) => {
    const { setFilter, filter} = props
    const [name, setName] = useState(filter?.name);
    const timer = useRef<any>(null);

    const handleKeyDown = (e: any) => {
        if (e.key === 'Enter') {
            clearTimeout(timer.current)
            setFilter({
                ...filter,
                page: 1,
                name: e.target.value?.trim(),
            })
        }
    }
    const handleChange = (e: any) => {
        clearTimeout(timer.current)
        const { name, value } = e?.target
        if(name == 'provinces_code') {
            setFilter({
                ...filter,
                page: 1,
                district_code: '',
                wards_code: '',
                [name]: value
            })
        }
        else if(name == 'district_code') {
            setFilter({
                ...filter,
                page: 1,
                wards_code: '',
                [name]: value
            })
        }
        else {
            setFilter({
                ...filter,
                page: 1,
                [name]: value
            })
        }
    }
    
    return (
        <Row className="mb-3 filter-custom">
            <Col xl={10}>
                <Row>
                    <Col xl={4}>
                        <InputGroup>
                            <InputGroupAddon addonType="prepend" className='input-group-prepend-input'>
                                <img src={IconSearch} width={18} height={18} alt=""/>
                            </InputGroupAddon>
                            <Input className='mb-2' onKeyDown={handleKeyDown} onChange={(e: any) => setName(e.target.value)} type="text" value={name} placeholder="Tên loại thu chi" />
                        </InputGroup>
                    </Col>
                    <Col xl={8}>
                        <Row>
                            <Col xl={3}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Loại thu chi-"
                                    options={[{
                                        label:'-Loại thu chi-',
                                        value: ''
                                    },...ReceiptsType]}
                                    onChange={(value: any) => {
                                        handleChange({ target: { name: 'type', value: value.value } })
                                    }}
                                    value={ReceiptsType?.filter((option: any) => filter?.type === option.value)}
                                ></Select>
                            </Col>
                            <Col xl={3}>
                                <Select
                                    className="react-select mb-2"
                                    classNamePrefix="react-select"
                                    placeholder="-Phân nhóm thu chi-"
                                    options={[{
                                        label:'-Phân nhóm thu chi-',
                                        value: ''
                                    },...ReceiptsGroup]}
                                    onChange={(value: any) => {
                                        handleChange({ target: { name: 'classify', value: value.value } })
                                    }}
                                    value={ReceiptsGroup?.filter((option: any) => filter?.classify === option.value)}
                                ></Select>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
            <Col xl={2}>
                <div className="text-right">
                    <Button 
                        onClick={() => props?.handleActionModal({type: 'add', data: {}})}
                        color="success" className="ml-2"
                    ><img className='mr-1' style={{border: 'none'}} src={IconPlus} width={20} height={20} alt=""/>  Thêm</Button>
                </div>
            </Col>
        </Row>
    );
};

const RenderActionModal = (props: any) => {
    const [loading, setLoading] = useState(false);
    const { closeModal, action, loadData } = props
    const router=useHistory()
    
    const handleDelete = async() => {
        setLoading(true)
        const url = `${baseUrl}/receiptstype/${action?.data?.id}`;
        let response: any = await APIClient.DELETE(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Xóa loại thu chi thành công')
            closeModal()
            loadData()
            router?.push('/setting/typereceipts/list')
        }
    }

    const handleStop = async() => {
        setLoading(true)
        const url = `${baseUrl}/receiptstype/${action?.data?.id}`;
        const params = {
            status: 0,
        }
        let response: any = await APIClient.PUT(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Ngưng hoạt động loại thu chi thành công')
            closeModal();
            loadData()
        }
    }

    const handleActive = async() => {
        setLoading(true)
        const url = `${baseUrl}/receiptstype/${action?.data?.id}`;
        const params = {
            status: 1,
        }
        let response: any = await APIClient.PUT(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Kích hoạt loại thu chi thành công')
            closeModal();
            loadData()
        }
    }

    if(action?.type == 'delete') {
        return (
            <CardBody className='p-0' style={{width:400}}>
                <div className="modal-header">
                    <h5 className="modal-title" id="modal-action-title">
                        Thông báo
                    </h5>
                    <button onClick={()=>closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
                </div>
                <div className="p-3 pt-4 text-center">Bạn có chắc chắn muốn xóa loại thu chi <b className='text-danger'>{action?.data?.name}</b></div>
                <div className="modal-footer">
                    <Button
                        onClick={closeModal}
                        className="ml-2 success-bland" color="success" type="button"
                    > Hủy bỏ</Button>
                    <Button
                        onClick={handleDelete}
                        className="ml-2" color="success" type="button"
                    > Xác nhận </Button>
                </div>
                {loading && <Loader />}
            </CardBody>
    
        )
    }

    if(action?.type == 'stop') {
        return (
            <CardBody className='p-0' style={{width:400}}>
                <div className="modal-header">
                    <h5 className="modal-title" id="modal-action-title">
                        Thông báo
                    </h5>
                    <button onClick={()=>closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
                </div>
                <div className="p-3 pt-4 text-center">Bạn có chắc chắn muốn ngừng hoạt động loại thu chi <b className='text-danger'>{action?.data?.name}</b></div>
                <div className="modal-footer">
                    <Button
                        onClick={closeModal}
                        className="ml-2 success-bland" color="success" type="button"
                    > Hủy bỏ</Button>
                    <Button
                        onClick={handleStop}
                        className="ml-2" color="success" type="button"
                    > Xác nhận </Button>
                </div>
                {loading && <Loader />}
            </CardBody>
    
        )
    }

    return (
        <CardBody className='p-0' style={{width:400}}>
            <div className="modal-header">
                <h5 className="modal-title" id="modal-action-title">
                    Thông báo
                </h5>
                <button onClick={()=>closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
            </div>
            <div className="p-3 pt-4 text-center">Bạn có chắc chắn muốn kích hoạt lại loại thu chi <b className='text-danger'>{action?.data?.name}</b></div>
            <div className="modal-footer">
                <Button
                    onClick={closeModal}
                    className="ml-2 success-bland" color="success" type="button"
                > Hủy bỏ</Button>
                <Button
                    onClick={handleActive}
                    className="ml-2" color="success" type="button"
                > Xác nhận </Button>
            </div>
            {loading && <Loader />}
        </CardBody>

    )
}

const mapState = (state: any) => {
    return {
        user: state.Auth.user,
    };
};

export default connect(mapState)(List)